'use strict';

export function showEditVaccinationPopup(options) {

    if (!options){
        options = {};
    }

    var popupTitle = '';

    if (!options.scheduleID) {
        options.scheduleID = 0;
    }

    if (!options.newRecord) {
        options.newRecord = false;
    }

    if (!options.newRecord) {
        // Existing Record
        popupTitle = $.i18n('EDIT_VACCINATION');
        options.newRecord = false;
    } else {
        // New Record
        popupTitle = $.i18n('ADD_VACCINATION');
        options.newRecord = true;
    }

    var editVaccinationURL = '/pages/pop/?' + jQuery.param({
        module: 'vaccination',
        page: 'vaccinationScheduleAdd',
        schedule_ID: options.scheduleID,
        newRecord: options.newRecord,
    });

    popWin({
        title: popupTitle,
        noAutoWidth: true,
        popID: 'editVaccinationSchedulePop',
        width: 600,
        modal: true,
        page: editVaccinationURL,
        dataType: 'json',
        buttons: {
            'Save': function() {
                saveForm('frmVaccinationScheduleHeaderSetUp',false, (data) =>
                {
                    var data = jQuery.parseJSON(data);
                    if (data.SAVED == 'true'){
                        popWinClose('editVaccinationSchedulePop');
                        $('#jqGridVaccinationSchedule').trigger('reloadGrid');
                    } else {
                        alert(data.RESULTMSG);
                    }
                });
            },
            'Close': function() {
                $(this).dialog('close');
            },
        },
    });
}

export function showDeleteVaccinationPopup(options){
    if (!options) {
        options = {};
    }

    if (!options.scheduleID) {
        options.scheduleID = 0;
    }

    if (!options.scheduleID){
        alert('Unable to continue as Vaccination Schedule ID not specified. Please try again.');
        return;
    }

    var popURL = '/pages/pop/?' + jQuery.param({
        module: 'vaccination',
        page: 'vaccinationScheduleDelete',
        schedule_id: options.scheduleID,
    });

    popWin({
        title: $.i18n('DELETE_VACCINATION'),
        noAutoWidth: true,
        popID: 'deleteVaccinationSchedulePop',
        width: 550,
        modal: true,
        page: popURL,
        buttons: {
            'Delete': function () {

                var deleteURL = '/components/general.cfc?' + jQuery.param({
                    'method': 'deleteItem',
                    'dbTable': 'vaccination',
                    'dbIDs': options.scheduleID,
                    'randomVar': gen_random(),
                    'csrfkey': $('#csrfkey').val(),
                });

                $.ajax({
                    type: 'POST',
                    url: deleteURL,
                    data: gen_random(),
                    dataType: 'JSON',
                    cache: false,
                    success: function(data) {
                        if (data.success == 'true'){
                            popWinClose('deleteVaccinationSchedulePop');
                            $('#jqGridVaccinationSchedule').trigger('reloadGrid');
                        } else {
                            EQLAPP.STRIPE.showAlert({
                                title: 'Alert',
                                body: 'There was a problem deleting this Vaccination.',
                            });
                        }
                    },
                    error: function() {
                        const errorMsg = 'An issue occured while attempting to';
                        errorMsg += ' delete the Vaccination. Please try again';
                        EQLAPP.STRIPE.showAlert({
                            title: 'Alert',
                            body: errorMsg,
                        });
                    },
                });

            },
            'Cancel': function () {
                $(this).dialog('close');
            },
        },
    });
}

export function clearVaccination(options){

    if (!options) {
        options = {};
    }

    if (!options.scheduleID) {
        options.scheduleID = 0;
    }

    if (!options.scheduleID){
        alert('Unable to continue as Vaccination Schedule ID not specified. Please try again.');
        return;
    }

    if (!options.horseID) {
        options.horseID = 0;
    }

    if (!options.horseID){
        alert('Unable to continue as Horse ID not specified. Please try again.');
        return;
    }

    $.ajax({
        type: 'GET',
        url: '/components/vaccination.cfc?method=deleteHorseVaccination&scheduleId=' +
            options.scheduleID + '&horseId=' + options.horseID,
        data: gen_random(),
        //dataType:	'JSON',
        cache: false,
        success: function() {
            refreshVaccinationGrid();
        },
    });

}

export function refreshVaccinationFromHistory(options){

    if (!options) {
        options = {};
    }

    if (!options.scheduleID) {
        options.scheduleID = 0;
    }

    if (!options.scheduleID){
        alert('Unable to continue as Vaccination Schedule ID not specified. Please try again.');
        return;
    }

    if (!options.horseID) {
        options.horseID = 0;
    }

    if (!options.horseID){
        alert('Unable to continue as Horse ID not specified. Please try again.');
        return;
    }

    $.ajax({
        type: 'GET',
        url: '/components/vaccination.cfc?method=updateFromDailyInput&schedule_ID=' +
            options.scheduleID + '&horse_ID=' + options.horseID,
        data: gen_random(),
        dataType: 'JSON',
        cache: false,
        success: function(data){
            if (data.SAVED){
                refreshVaccinationGrid();
            }
        },
    });

}

export function addVaccination(options)
{
    if (!options) {
        options = {};
    }

    if (!options.scheduleID) {
        options.scheduleID = 0;
    }

    if (!options.scheduleID){
        alert('Unable to continue as Vaccination Schedule ID not specified. Please try again.');
        return;
    }

    if (!options.horseID) {
        options.horseID = 0;
    }

    if (!options.horseID){
        alert('Unable to continue as Horse ID not specified. Please try again.');
        return;
    }

    if (!options.horseName) {
        options.horseName = '';
    }

    if (!options.horseName){
        alert('Unable to continue as Horse Name not specified. Please try again.');
        return;
    }

    var activityParams = $.param({
        horseId: options.horseID,
        horseName: options.horseName,
        scheduleId: options.scheduleID,
        type: 'vet',
    });

    var URL = '/pages/daily_activity_input.cfm?fromVaccination=true&' + activityParams;
    popWin({
        popID: 'addActivityPopup',
        title: 'Add Vaccination' + ' - ' + options.horseName,
        modal: true,
        page: URL,
        noAutoWidth: true,
        width: 760,
    });

    $('#addActivityPopup').bind('dialogclose', (event) => {
        if (!event.cancelable){
            refreshVaccinationFromHistory({
                scheduleID: options.scheduleID,
                horseID: options.horseID,
            });
        }
    });
}

export function init(options) {
    if (!options) {
        options = {};
    }
    $('.jq_button').button();
}

function refreshVaccinationGrid(){
    $('#jqGridHorseVaccination').trigger('reloadGrid');
}